import styled from 'styled-components';
export const InputItem = styled.div`
    .inputSearch {
        background: ${(props) => props.background ? props.background : 
            '#ffffff 0% 0% no-repeat padding-box'};
        border: ${(props) =>
            props.isShipTo
                ? 'none !important'
                : props.isBorderColor? 
                    '1px solid #4f4f4f59':'1px solid #ebeded' 
                };
        border-radius: ${(props) => props.borderRadius ? props.borderRadius : '4px'};
        padding-right: 16px;
        font-size: 14px;
        padding-left: 10px;
        padding-top: ${(props) => 
            props.paddingTop ? props.paddingTop : props.isShipTo ? '3px' : ''};
        height: ${(props) => props.height ? props.height : ''};
        &:hover { 
            border: 1px solid #000000 !important;
        }       
    }
    .MuiChip-root {
        margin: 0 !important;
    }
    .MuiAutocomplete-inputRoot {
        border-color: #ffffff !important;
        flex-wrap: ${(props) =>
            props.isDefault ? (props.isDefault ? 'nowrap' : '') : ''};
    }
    .full-width-autocomplete {
        width: 100% !important;
        max-width: 100% !important;
    }
    .full-width-autocomplete .MuiInputBase-root {
        width: 100% !important;
        max-width: 100% !important;
    }
    .MuiInput-underline:before {
        border-color: #ffffff !important;
    }
    .MuiInput-underline:after {
        border-color: #ffffff !important;
    }
    .MuiInputBase-input {
        font-family: AvenirNextWorld Regular;
        padding: ${(props) => (props.padding && props.padding)};
    }
    .searchtStyle {
        border-width: ${(props) =>
            props.bwidth ? props.bwidth : '0 !important'};
        width: ${(props) =>
            props.scrWidth ? props.scrWidth : '100% !important'};
        outline: ${(props) => (props.outline ? props.outline : '0 !important')};
        padding: ${(props) => (props.pd ? props.pd : '6px !important')};
        background: ${(props) =>
            props.background
                ? props.background
                : '#FFFFFF 0% 0% no-repeat padding-box'};
        border: ${(props) => (props.border ? props.border : '0px !important')};
        border-radius: ${(props) =>
            props.borderRadius ? props.borderRadius : '0px !important'};
        opacity: ${(props) =>
            props.opacity ? props.opacity : '0px !important'};
    }
`;
